import { Container, Grid, TableCell } from '@mui/material';
import { styled } from '@mui/system';
export const TableContainer = styled('div')``;
export const Table = styled('table')``;
export const TableHead = styled('thead')`
.col-header{
        background-color: #d1d2d4;
        border-bottom: 2px solid #fffff;
        min-height: 100px;
        border-right: 2px solid #fff;
    }
.col-header-wrapper{
        display: flex;
        flex-direction: column;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        height: 100%;
        text-align: center;
        
        p {
            font-size: 1rem;
            font-weight: 600;
            margin: 8px 0 0 0;
            color: #333;
            line-height: 1.2;
        }
    }
        img{
        padding: 8px;
        max-width: 183px;
        height: auto;
        @media(max-width:430px){
            width: 100%;
            height: auto;
            padding: 4px;
        }
    }
.rep-header{
        background-color: #2372b9;
        color: #333;
        padding: 16px 12px !important;
        border-right: 2px solid white;
        img{
            width: auto;
            padding: 0;
        }
    .sub-title{
        font-size: 0.9rem;
        font-weight: 400 !important;
        color: #666;
        margin-top: 4px;
        @media(max-width:430px){
            font-size: 0.7rem;
        }
    }
.border-light2{
            border-bottom: 2px solid #fff;
        }

`;
export const TableBody = styled('tbody')``;
export const TableRow = styled('tr')``;
export const TableHeaderCell = styled('th')``;
export const TableFooter = styled('footer')``;

// KH Plan Modal Styled Components
export const KHModalTitle = styled('h2')`
    color: #2372B9;
    font-size: 1.5rem !important;
    text-align: left;
    font-weight: bold;
    margin: 0;
    line-height: 1.2;
`;

export const KHPlanCard = styled('div')`
    background-color: #fff;
    border: 2px solid #E5E5E5;
    border-radius: 24px;
    padding: 20px 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 16px;
`;

export const KHPlanHeader = styled('div')`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
`;

export const KHPlanLogo = styled('div')`
    flex-shrink: 0;
    margin-right: 12px;
    
    img {
        max-width: 125px;
        height: auto;
    }
`;

export const KHPlanName = styled('div')`
    font-size: 1.125rem;
    font-weight: 500;
    color: #333;
`;

export const KHPlanDetails = styled('div')`
    margin-bottom: 16px;
`;

export const KHPlanSummaryRow = styled('div')<{ narrow?: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: ${({ narrow }) => narrow ? '4px 0' : '12px 0'};
    font-size: 14px;
    line-height: 1.2;

    label {
        font-weight: 500;
        color: #333;
    }

    span {
        color: #000;
        font-size: 1rem;
    }

    b {
        font-weight: 700;
        font-size: 1rem;
        color: #000;
    }
`;

export const KHPlanLinks = styled('div')`
    margin: 16px 0;
`;

export const KHPlanLink = styled('a')`
    display: flex;
    align-items: center;
    color: #2372B9;
    text-decoration: none;
    font-size: 14px;
    margin: 4px 0;
    
    &:hover {
        text-decoration: underline;
    }
    
    .ms-2 {
        margin-left: 8px;
    }
`;

export const KHPlanPromote = styled('div')`
    padding-top: 8px;
    font-size: 12px;
    color: #999;
    margin-bottom: 16px;
`;


export const KHModalButton = styled('button')<{ variant?: 'primary' | 'secondary' }>`
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    
    ${({ variant }) => variant === 'primary' ? `
        background-color: #2372B9;
        color: white;
        border: none;
        
        &:hover {
            background-color: #1a5a8a;
        }
    ` : `
        background-color: transparent;
        color: #2372B9;
        border: 1px solid #2372B9;
        
        &:hover {
            background-color: rgba(35, 114, 185, 0.04);
            border-color: #1a5a8a;
        }
    `}
`;
    